module.exports = __webpack_public_path__ + "static/media/automations_plus.f9f0637a.svg";